import React from 'react';
import { func, string } from 'prop-types';

const ConfirmModal = ({
  firstButtonClick,
  secondButtonClick,
  modalMessage = "Are you sure",
  firstButtonText = 'No',
  secondButtonText = 'Yes'
}) => {
  return (
    <div className="de__confmodal--body">
      <span >{modalMessage}</span>
      <div className="de__confmodal--actions">
        <button
          type="button"
          onClick={firstButtonClick}
          className="de--btn de--btn--outline__primary"
        >
          {firstButtonText}
        </button>
        <button
          type="button"
          onClick={secondButtonClick}
          className="de--btn de--btn__primary"
        >
          {secondButtonText}
        </button>
      </div>
    </div>
  );
};

ConfirmModal.propTypes = {
  firstButtonClick: func,
  secondButtonClick: func,
  modalMessage: string,
  firstButtonText: string,
  secondButtonText: string
};

export default ConfirmModal;
